import Vue from "vue"
import router from "../router"
import store from "../store"

class Routing {
  init(router) {
    this.router = router
  }

  set router(router) {
    router.beforeEach((to, from, next) => {
      const isAllowed = to.name === "contest-closed" || to.name === "rules"
      if (store.state.app.isContestClosed && !isAllowed) {
        console.log("Contest closed. Redirecting...")
        return next({ name: "contest-closed" })
      } else {
        next()
      }
    })
  }
}

let routing = new Routing()

Routing.install = function(Vue, { router }) {
  routing.init(router)

  //Vue.prototype.$can = function(permission) {
  //  return acl.check(permission)
  //}
}

Vue.use(Routing, { router: router })
